var React = require('react');

function MeetupIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.98 18.33c-.3-1.96-3.88-.45-4.1-2.6-.31-3.02 4.15-9.55 3.8-12.09C23.37 1.36 21.84.88 20.5.86c-1.28-.02-1.62.18-2.05.44-.26.14-.62.44-1.12-.05-.33-.32-.55-.54-.9-.82a1.9 1.9 0 00-.95-.4c-.47-.07-1.1 0-1.49.17-.4.17-.7.47-1.02.75-.33.29-1.15 1.21-1.92.87-.33-.15-1.45-.71-2.27-1.06-1.56-.69-3.82.42-4.63 1.88C2.94 4.81.56 13.36.19 14.48-.6 17 1.23 19.07 3.7 18.95c1.05-.05 1.75-.43 2.41-1.66.39-.7 3.98-10.19 4.25-10.65.2-.33.85-.76 1.4-.48.54.29.65.88.57 1.44-.13.9-2.67 6.7-2.77 7.35-.16 1.11.36 1.73 1.5 1.8.8.03 1.58-.25 2.2-1.43.34-.66 4.34-8.76 4.7-9.3.38-.6.7-.79 1.1-.77.3.02.8.1.68 1.03-.13.91-3.35 6.85-3.68 8.3a4.31 4.31 0 002.34 4.78c1.11.55 5.97 1.5 5.58-1.03z","fill":"currentColor"}));
}

MeetupIcon.defaultProps = {"viewBox":"0 0 25 22","fill":"none"};

module.exports = MeetupIcon;

MeetupIcon.default = MeetupIcon;
